import { getButton } from '~/js/utils/selectors';
import { addClass, removeClass } from '~/js/utils/class-management';

function makeModals() {
  const modal = document.querySelector('.wp-block-clickbus-modal');
  if (modal) {
    addClass(modal, 'opened');
    const buttonClose = getButton('.button-close', modal);

    buttonClose.addEventListener('click', () => {
      removeClass(modal, 'opened');
    });
  }
}

export default makeModals;
